export default __webpack_public_path__ + "static/media/fmbmi-green.eefb6c0a.png";